/**
 * Created by hernanherreros on 2019-05-09
 */

import * as React from 'react'
import { RouteComponentProps } from 'react-router'
import { flowRight } from 'lodash'
import { Trans } from '@lingui/macro'
import styled from 'styled-components'
import 'moment/locale/es'
import { space, SpaceProps } from 'styled-system'
import appStore from '../../../../static/images/storeBadges/appStore.svg'
import googlePlay from '../../../../static/images/storeBadges/googlePlay.png'
import Section from '../../../../components/Section/Section'
import LoaderWrapper from '../../../../components/Utils/LoaderWrapper'
import Col from '../../../../components/Form/Col'
import Row from '../../../../components/Form/Row'
import DetailResolver from '../../../../components/Resolvers/DetailResolver'
import { getReservation } from '../../../../requests/inscription'
import { RouterItem } from '../../../../config/router.config'
import withCongress, { ComponentProps } from '../../../../providers/Congress/withCongress'
import withWizardProps, { WizardProps } from '../../../../wrappers/withWizardParams'
import withReservation, { ReservationProps } from '../../../../providers/Reservation/withReservation'
import Button from '../../../../components/Utils/Button'
import { getSharingPath } from '../../../../helpers/wizard'
import { getAppURL, openAppURL } from '../../../../helpers/general'
import withURLParams, { URLParamsComponentProps } from '../../../../providers/URLParams/withURLParams'

interface Props extends ComponentProps, RouteComponentProps, WizardProps, ReservationProps, URLParamsComponentProps {
  step: RouterItem;
  congress?: any;
}

interface State {
  values: any,
  isValid: boolean,
  isLoading: boolean,
}

class Success extends React.Component<Props, State> {
  state: State = {
    values: {},
    isValid: true,
    isLoading: false,
  }

  componentWillMount () {
    this.handleParams()
  }

  handleParams = () => {
    const { params, reservation } = this.props
    console.log('params', params)
    if (params && params.returnTo && params.skipSuccess) {
      var url = params.returnTo.replace('%3Aemail', reservation.data.Email)
      console.log('hi', url)
      openAppURL(params.returnTo.replace('%3Aemail', reservation.data.Email))
    }
  }

  render () {
    const { wizard } = this.props

    return (
      <DetailResolver
        requestFunction={async () => {
          try {
            const inscriptionData = await getReservation({ id: wizard.token })

            return {
              inscription: inscriptionData.Data,
            }
          } catch (e) {
            return { inscription: null }
          }
        }}
        render={this.renderContent}
      />
    )
  }

  handleFinish = () => {
    const { congress, history, params, reservation } = this.props
    const url = getAppURL(congress.Slug)
   
    if (params && params.returnTo) {
      openAppURL(params.returnTo.replace('%3Aemail', reservation.data.Email))
    } else {
      history.push(getSharingPath(congress.Slug))
    }
  }

  renderContent = (data: any) => {
    const { isLoading } = this.state
    const { congress } = this.props

    return (
      <LoaderWrapper isLoading={isLoading}>
        <Section>
          <Row gutter={32} m={0} align="top">
            <Col md={7}>
              <BannerContainer>
                <Banner src={congress.ScreenshotURL}/>
              </BannerContainer>
            </Col>

            <Col md={17}>
              <h1><Trans>¡Inscripción finalizada, ahora debe esperar a que la organización confirme su inscripción!</Trans></h1>
              <h3><Trans>¡Recibirá un correo cuando la inscripción sea confirmada!</Trans></h3>
              <h3><strong>¿No le ha llegado el correo?</strong></h3>
              <p><Trans>Si no le llega nuestro correo en los próximos minutos, puede haber pasado una de las siguientes cosas:</Trans></p>
              <ul>
                <li><Trans>El correo está en su carpeta de spam. (Las cosas se pierden ahí a veces.)</Trans></li>
                <li><Trans>El correo ingresado tiene errores de tipeo. (A cualquiera le puede pasar.)</Trans></li>
                <li><Trans>Accidentalmente ingresó otro correo. (Usualmente uno personal o de trabajo en vez de el que usted quería ingresar.)</Trans></li>
                <li><Trans>No podemos envíar el correo a su dirección. (Usualmente por causa de firewalls o filtros de su corporación.)</Trans></li>
              </ul>
              <h1><Trans>¡Próximamente podrá descargar la app del evento!</Trans></h1>
              <h3><Trans>Con la aplicación podrá:</Trans></h3>
              <ul>
                <li><Trans>Acreditarse rápidamente el día del evento, con tu código QR.</Trans></li>
                <li><Trans>Revisar el programa y sus respectivos detalles.</Trans></li>
                {/* <li><Trans>Ver tu agenda del evento, con los horarios y salas de tus actividades inscritas.</Trans></li> */}
                <li><Trans>Ver los expositores que participarán y sus detalles.</Trans></li>
                <li><Trans>Ver las empresas que participarán de la Expo</Trans></li>
                <li><Trans>Revisar las noticias del evento.</Trans></li>
                <li><Trans>Recibir notificaciones sobre novedades y avisos importantes.</Trans></li>
                <li><Trans>Entregar feedback el día del evento.</Trans></li>
                <li><Trans>Contactarse con la organización.</Trans></li>
              </ul>

              {congress.AppStoreURL || congress.GooglePlayURL ? 
                <StoreBadgesText><Trans>Descarguela ahora</Trans></StoreBadgesText> : null
              }
              
              <StoreBadges>
                {congress.AppStoreURL ? 
                  <a href={congress.AppStoreURL} target="_blank">
                    <AppStoreBadge src={appStore} alt="Download on the App Store"/>
                  </a> : null}
                
                {congress.GooglePlayURL ? 
                  <a href={congress.GooglePlayURL} target="_blank">
                    <StoreBadge src={googlePlay} alt="Get it on Google Play"/>
                  </a> : null}

              </StoreBadges>
            </Col>
          </Row>

          {/* <div style={{ textAlign: 'center', marginBottom: 16 }}>
            <Button color={congress.PrimaryColor} onClick={this.handleFinish}>
              <Trans>¡Finalizar registro!</Trans>
            </Button>
          </div> */}
        </Section>

        <Legal>Google Play and the Google Play logo are trademarks of Google LLC.</Legal>
        <Legal>Apple, the Apple logo, iPhone, and iPad are trademarks of Apple Inc., registered in the U.S. and other
          countries and regions. App Store is a service mark of Apple Inc.</Legal>
      </LoaderWrapper>
    )
  }
}

const Legal = styled.div`
  text-align: center;
  margin-top: 16px;
  font-size: 14px;
  color: #cccccc;
`

const StoreBadgesText = styled.h3`
  margin-top: 24px;
`

const StoreBadges = styled.div`
  margin-top: 8px;
  margin-bottom: 16px;
`

const StoreBadge = styled.img`
  width: 150px;
`

const AppStoreBadge = styled(StoreBadge)`
  max-height: 40px;
`

const Heading = styled.h1`
  text-align: center;
`

const SubHeading = styled.h3`
  margin-top: 16px;
  margin-bottom: 16px;
  text-align: center;
`

const ErrorWrapper = styled.div<SpaceProps>`
  * {
    display: block;
    text-align: center;
    width: 100%;
  }
  
  ${space}
`

const BannerContainer = styled.div`
  text-align: center;
  margin-bottom: 16px;
`

const Banner = styled.img<SpaceProps & any>`
  width: 100%;
  max-width: 200px;
  border-radius: 5px;

  ${({ hidden }) => hidden && 'display: none;'}
  
  ${space}
`

const Notice = styled.p`
  margin-top: 32px;
`

export default flowRight([withCongress, withWizardProps, withReservation, withURLParams])(Success)
